import styled from "styled-components";
const Discription = () => {
  return (
    <Container>
      <div>
        <div>
          <h4>بلیط هواپیما</h4>
          <p>
            خرید بلیط پرواز خارجی در سایت خرید اینترنتی بلیط و علی گشت در
            سریع‌ترین زمان ممکن و کاملا آنلاین انجام می‌شود. سیستم رزرواسیون
            بلیط هواپیما و هتل علی گشت به شما امکان می‌دهد تا بهترین قیمت بلیط
            هواپیما در ایرلاین های مختلف را مقایسه کنید و با پرداخت از طریق کارت
            های شتاب، خرید اینترنتی بلیط هواپیما را تجربه کنید و بلیط پرواز
            خارجی را در سریعترین زمان رزرو کنید. خرید بلیط ایران ایر، بلیط
            هواپیمایی ماهان و دیگر ایرلاین های ایرانی و همچنین ایرلاین های خارجی
            از جمله امارات، ترکیش، لوفتهانزا، بریتیش ایرویز، ایرفرانس و بسیاری
            از ایرلاین‌های دیگر در علی گشت با پرداخت ریالی از طریق کارت های شتاب
            با ارزان ترین قیمت ممکن است.
          </p>

          <h4>مزایای خرید از علی گشت</h4>
          <p>
            علی گشت با استفاده از تکنولوژی های جدید و آنلاین، بهترین خدمات خرید
            بلیط هواپیما خارجی و داخلی، رزرو هتل خارجی، رزرو قطار خارجی، خرید
            بیمه مسافرتی، ترانسفر فرودگاهی و کشتی کروز را در سراسر دنیا به
            مشتریان خود ارائه می دهد. ارزان ترین قیمت بلیط هواپیما خارجی و رزرو
            هتل خارجی در فلای تودی پیش روی شماست تا با چند کلیک رزرو و خرید خود
            را کاملا آنلاین انجام دهید. خرید بلیط ارزان قیمت و بلیط لحظه آخری در
            کنار رزرو هتل های لوکس و همچنین رزرو قطارهای خارجی و بلیط پرواز
            خارجی در اروپا و سراسر دنیا با بهترین قیمت فراهم شده است. فلای تودی
            نماینده شرکت هواپیمایی Hahn Air در ایران نیز است و خرید اینترنتی
            بلیط هواپیما خارجی را با ارزان ترین قیمت ارائه می‌دهد.
          </p>
        </div>
        <img src="/images/trip-vector.png" alt="" />
      </div>
      <p>
        یکی از ابزارهای بسیار مفید و کاربردی برای خرید اینترنتی بلیط هواپیما،
        تقویم قیمتی است. با استفاده از تقویم قیمتی شما می‌توانید کمترین و
        بیشترین قیمت بلیط پرواز را در روزهای قبل و بعد از آن تاریخ مشاهده کنید.
        در صورتی که اصرار به خرید بلیط هواپیما در یک روز خاص نداشته باشید، این
        امکان به شما کمک می‌کند تا مبلغ بلیط هواپیما برایتان با مبلغ به صرفه تری
        تمام شود. علاوه بر این، با استفاده از فیلترهای کنار صفحه می‌توانید
        ایرلاین مورد نظرتان را انتخاب کنید. ضمنا می‌توانید، بلیط چارتر هواپیما
        یا سیستمی را فعال کنید تا فقط یکی از این دو نوع بلیط را مشاهده کنید.
        بلیط هواپیما خارجی ،کلاس پروازی و زمان پرواز هم از دیگر گزینه‌هایی است
        که با انتخاب آنها، تعداد بلیط ها محدودتر و رزرو بلیط هواپیما برای شما
        آسانتر می‌شود. برای پرداخت هزینه می‌توانید از کارت شتاب استفاده کنید. پس
        از پرداخت، خرید اینترنتی بلیط هواپیما با موفقیت انجام میشود و بلیط به
        ایمیل شما ارسال میشود. همچنین در همه این مراحل، پشتیبانی علی گشت در کنار
        شماست تا هر زمانی که سوال یا مشکلی داشتید، 24 ساعته پاسخگوی شما باشد.
      </p>
    </Container>
  );
};

export default Discription;

const Container = styled.div`
  width: 1120px;
  margin-top: 55px;
  margin: auto;
  direction: rtl;

  @media (max-width: 900px) {
    width: 90vw;
  }
  @media (max-width: 1100px) {
    width: 98vw;
  }

  & > div {
    display: flex;

    div {
      padding-top: 10px;

      p {
        text-align: justify;
        font-size: 15px;
        font-weight: 100;
        color: #6b6b6b;
        line-height: 30px;
      }

      h4 {
        margin: 25px 0 0 0;
        font-size: 17px;
        color: #000;

        @media (max-width: 900px) {
          padding: 10px;
        }
      }
    }
    img {
      max-width: 488px !important;
      max-height: 512px !important;

      @media (max-width: 900px) {
        display: none !important;
      }
    }
  }

  p {
    padding-top: 10px;
    text-align: justify;
    font-size: 15px;
    font-weight: 100;
    color: #6b6b6b;
    line-height: 30px;

    @media (max-width: 900px) {
      padding: 10px;
    }
  }
`;
